/* GCA perf 2026-08-20
 * 1) Lazy mobile navigation: the drawer ships with top-level links only; the full
 *    nested tree is fetched from /?section_id=mobile-navigation-menu on the first
 *    interaction and merged into the existing <details> items.
 * 2) Desktop hover-panel script (moved unchanged from layout/theme.liquid).
 */
(function () {
  var list = document.querySelector('[data-gca-lazy-menu]');
  if (!list) return;
  var promise = null;

  // Placeholder headings expand their own menu instead of navigating to #.
  // Delegate to the list so headings loaded on demand behave the same way.
  list.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('summary > a.details__link[href="#"]');
    if (!link || !list.contains(link)) return;
    var details = link.parentElement.parentElement;
    if (details.tagName !== 'DETAILS') return;
    event.preventDefault();
    details.open = !details.open;
  });


  function hydrate(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var full = doc.querySelector('[data-gca-lazy-menu-full]');
    if (!full) throw new Error('gca-nav-lazy: full menu not found');
    var fullItems = Array.prototype.slice.call(full.children);
    var curItems = Array.prototype.slice.call(list.children);
    var sameShape = fullItems.length === curItems.length && fullItems.every(function (fi, i) {
      var fa = fi.querySelector('a'); var ca = curItems[i].querySelector('a');
      return fa && ca && fa.getAttribute('href') === ca.getAttribute('href');
    });
    if (sameShape) {
      fullItems.forEach(function (fi, i) {
        var ci = curItems[i];
        var fullDetails = fi.firstElementChild && fi.firstElementChild.tagName === 'DETAILS' ? fi.firstElementChild : null;
        var curDetails = ci.firstElementChild && ci.firstElementChild.tagName === 'DETAILS' ? ci.firstElementChild : null;
        if (fullDetails && curDetails) {
          var fc = fullDetails.querySelector(':scope > .details__content');
          var cc = curDetails.querySelector(':scope > .details__content');
          if (fc && cc) { cc.innerHTML = fc.innerHTML; cc.removeAttribute('data-gca-lazy-menu-slot'); }
        } else if (fullDetails || curDetails) {
          ci.replaceWith(fi);
        }
      });
    } else {
      list.innerHTML = full.innerHTML;
    }
    list.setAttribute('data-gca-lazy-menu-state', 'ready');
    document.dispatchEvent(new CustomEvent('gca:mobile-menu:ready'));
  }

  function load() {
    if (promise) return promise;
    list.setAttribute('data-gca-lazy-menu-state', 'loading');
    promise = fetch(list.getAttribute('data-gca-lazy-menu-src'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('gca-nav-lazy: HTTP ' + r.status); return r.text(); })
      .then(hydrate)
      .catch(function (err) {
        promise = null;
        list.setAttribute('data-gca-lazy-menu-state', 'error');
        if (window.console) console.warn(err);
      });
    return promise;
  }
  window.gcaLoadMobileMenu = load;

  var triggers = document.querySelectorAll('[popovertarget="slideout-mobile-navigation"], [data-wau-slideout-target="mobile-navigation"]');
  Array.prototype.forEach.call(triggers, function (t) {
    ['pointerenter', 'pointerdown', 'touchstart', 'focus', 'click'].forEach(function (ev) {
      t.addEventListener(ev, load, { passive: true });
    });
  });
  var aside = document.getElementById('slideout-mobile-navigation');
  if (aside) {
    aside.addEventListener('beforetoggle', load);
    aside.addEventListener('toggle', load);
  }
  if (window.matchMedia && window.matchMedia('(max-width: 980px)').matches) {
    var evs = ['touchstart', 'pointerdown', 'keydown', 'scroll'];
    var once = function () { load(); evs.forEach(function (ev) { document.removeEventListener(ev, once); }); };
    evs.forEach(function (ev) { document.addEventListener(ev, once, { passive: true }); });
  }
  if (window.Shopify && window.Shopify.designMode) load();
})();

      (() => {
        const activeClass = 'gca-hover-item--active';

        const setActiveSport = (item) => {
          const list = item && item.closest('.gca-hover-list');
          if (!list) return;

          list.querySelectorAll(`.${activeClass}`).forEach((activeItem) => {
            activeItem.classList.remove(activeClass);
          });
          item.classList.add(activeClass);
        };

        const bindMenu = (list) => {
          if (list.dataset.gcaHoverBound === 'true') return;
          list.dataset.gcaHoverBound = 'true';

          list.querySelectorAll('.gca-hover-item--has-panel').forEach((item) => {
            item.addEventListener('mouseenter', () => setActiveSport(item));
            item.addEventListener('pointerenter', () => setActiveSport(item));
            item.addEventListener('focusin', () => setActiveSport(item));
          });

          list.addEventListener('mousemove', (event) => {
            const link = event.target.closest('.gca-hover-link');
            const item = link && link.closest('.gca-hover-item--has-panel');
            if (item && list.contains(item)) setActiveSport(item);
          });
        };

        const primeMenus = () => {
          document.querySelectorAll('nav.navigation .gca-hover-list').forEach((list) => {
            bindMenu(list);
          });
        };

        document.addEventListener('pointerover', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        document.addEventListener('mouseover', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        document.addEventListener('focusin', (event) => {
          const link = event.target.closest('nav.navigation .gca-hover-link');
          const item = link && link.closest('.gca-hover-item--has-panel');
          if (item) setActiveSport(item);
        });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', primeMenus);
        } else {
          primeMenus();
        }
      })();
    

/* GCA 2026-09-06: viewport-aware desktop menu placement, including flyouts
 * outside a scrolling parent. Delegate so theme section replacements work. */
(() => {
  const desktop = window.matchMedia('(min-width: 981px)');
  const pad = 8;
  let frame = 0;
  const clamp = (n, min, max) => Math.max(min, Math.min(n, Math.max(min, max)));
  function place(item, nested) {
    const panel = item.querySelector(':scope > .dropdown');
    const link = item.querySelector(':scope > a');
    if (!panel || !link) return;
    const anchor = link.getBoundingClientRect();
    const width = Math.min(322, window.innerWidth - pad * 2);
    let left, top;
    if (nested) {
      const parent = item.parentElement.getBoundingClientRect();
      left = parent.right + width <= window.innerWidth - pad ? parent.right - 1 : parent.left - width + 1;
      // Measure the natural list height, including padding and borders.
      const height = Math.min(panel.scrollHeight + 2 || 250, window.innerHeight - pad * 2);
      top = clamp(anchor.top - 20, pad, window.innerHeight - height - pad);
    } else {
      left = anchor.left - 16;
      top = clamp(anchor.bottom, pad, window.innerHeight - 80);
    }
    panel.classList.add('gca-menu-positioned');
    panel.style.setProperty('--gca-menu-width', width + 'px');
    panel.style.setProperty('--gca-menu-left', clamp(left, pad, window.innerWidth - width - pad) + 'px');
    panel.style.setProperty('--gca-menu-top', top + 'px');
    panel.style.setProperty('--gca-menu-height', (window.innerHeight - top - pad) + 'px');
  }
  function update() {
    frame = 0;
    if (!desktop.matches) return;
    document.querySelectorAll('nav.navigation .navigation__menuitem').forEach(item => {
      if (!item.matches(':hover, :focus-within, .navigation__menuitem--active')) return;
      place(item, false);
      item.querySelectorAll('.dropdown__menuitem--nested').forEach(child => {
        if (child.matches(':hover, :focus-within, .dropdown__menuitem--active')) place(child, true);
      });
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function enter(event) {
    if (!desktop.matches || !event.target.closest?.('nav.navigation')) return;
    update();
    schedule(); // Include the theme's keyboard/hover state changes.
  }
  document.addEventListener('pointerover', enter);
  document.addEventListener('focusin', enter);
  document.addEventListener('keydown', enter);
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
})();
